module.exports = __webpack_public_path__ + "img/01-9.0b70c90d.png";